import { Fragment, useEffect, useMemo } from 'react';
import { ITEMS_TO_DISPLAY, MenuItem } from '../types';
import ShortList from '../ShortList';
import { SubcategorieProps } from './types';
import clsx from 'clsx';

import styles from './SubCategorie.module.css';

const SubCategorie = ({ subCategorie, handleMenuBack, active, mainUrl, mobile, mainCategory }: SubcategorieProps) => {
  const handleMenuReturn = (el: React.MouseEvent<HTMLElement>) => {
    el.stopPropagation();
    handleMenuBack();
  };

  useEffect(() => {
    const editedList = document.querySelectorAll(
      '.shortList:first-child li:not(.mmGuide)',
    ) as unknown as Array<HTMLElement>;
    if (editedList?.length > ITEMS_TO_DISPLAY) {
      for (let item = 0; item < editedList.length; item++) {
        if (item > ITEMS_TO_DISPLAY) {
          editedList[item].remove();
        }
      }
      const editedListOfMenu = document.querySelector('.shortList:first-child');
      if (editedListOfMenu) {
        editedListOfMenu.insertAdjacentHTML('beforeend', '<li><a href="/brands">View More</a></li>');
      }
    }
  }, [subCategorie?.html]);

  const sortedSubCategorie = useMemo(() => {
    const rows = {
      empty: [] as Array<MenuItem>,
      nonEmpty: [] as Array<MenuItem>,
    };
    subCategorie?.sub?.forEach((element: MenuItem) => {
      if (element?.sub?.length === 0) {
        rows.empty.push({ ...element });
      } else {
        rows.nonEmpty.push({ ...element });
      }
    });
    return rows;
  }, []);

  return (
    <div
      className={clsx(styles.subCategorie, 'mmBox', {
        [styles.subCategorieSlide]: active && mobile,
        [styles.subCategorieActive]: active,
      })}
      id="mmSlider"
    >
      <span className={styles.allLinks}>
        <a data-testid={'sub-category-show-all'} href={mainCategory.url}>
          Shop All {mainCategory.name}
        </a>
      </span>
      {mobile && (
        <p
          data-testid={`sub-category-back-${subCategorie?.id}`}
          className={styles.subCategoriesName}
          onClick={handleMenuReturn}
        >
          <span className={styles.subCategorieBackIcon} />
          <span className={styles.subCategorieDescription}>{subCategorie?.name}</span>
        </p>
      )}

      <div className={'sub-categories'} id={`mmSub_${subCategorie?.id}`}>
        <div className={`${styles.subList} topElement`}>
          <div className={`${styles.allLinksMobile} subList mainSubElement`}>
            <a data-testid={'sub-category-show-all-mobile'} href={mainCategory.url}>
              Shop All {mainCategory.name}
            </a>
          </div>
          {Object.keys(sortedSubCategorie).map((key: string) => {
            const group: Array<MenuItem> = sortedSubCategorie[key];
            if (group.length === 0) return <Fragment key={`empty-${key}`}></Fragment>;
            if (key === 'empty')
              return (
                <div key={key} className="subList">
                  {group.map((shortList: MenuItem) => (
                    <div
                      key={`${shortList.parentId}-${shortList.id}`}
                      data-testid={`sub-list-${shortList.parentId}-${shortList.id}`}
                      className={`${styles.noSubListLink} mainSubElement`}
                    >
                      <ShortList shortList={shortList} mainUrl={mainUrl} />
                    </div>
                  ))}
                </div>
              );
            return (
              <Fragment key={key}>
                {group.map((shortList: MenuItem) => (
                  <div
                    data-testid={`sub-list-${shortList.parentId}-${shortList.id}`}
                    className="subList"
                    key={`${shortList.parentId}-${shortList.id}`}
                  >
                    <ShortList shortList={shortList} mainUrl={mainUrl} />
                  </div>
                ))}
              </Fragment>
            );
          })}
          {subCategorie?.html && (
            <div
              dangerouslySetInnerHTML={{ __html: subCategorie.html }}
              className={clsx(styles.subListContainer, 'subList menu__small-text', {
                [styles.subListContainerActive]: subCategorie?.sub && subCategorie?.sub.length === 0,
              })}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SubCategorie;
